import React from 'react'
import DataItem from '../Components/DataItem/DataItem'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'

const DataItemPage = ({data}) => {
  return (
    <div>
      <Header/>
    <DataItem data={data}/>
    <Footer/>
    </div>
  )
}

export default DataItemPage